module.exports = __webpack_public_path__ + "media/images/emblems/Wuppenau-Blazono-edd9261f4d410ad78952ca0bdc9fcbf5.png";